import AppWrapper from './AppWrapper'
import React, { useEffect } from 'react'
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { appUrls } from '../../utils/urls/appUrls'
import '../../assets/css/layoutStyles.css'
import '../../assets/css/certifcateStyles.css'
import { clearAll, clearResponseMsg, clearOnReload, logoutTransfereeUser } from '../../config/redux/slice/transfereeUserSlice'
import { logoutAppUser, onGetCurrencies, setActiveSidebar } from '../../config/redux/slice/appSlice';
import { getRequest } from '../../helpers/request';
import { appApi } from '../../utils/endpoints/appApi';
import { handleOnPageLoad, handleOverlayClick } from '../../helpers/sideBarToggle';
import { logoutUser } from '../../config/redux/slice/authSlice';
import { logoutBankUser } from '../../config/redux/slice/bankUserSlice';
import { logoutNotapUser } from '../../config/redux/slice/notapUserSlice';

export default function TransfereeWrapper({children, pageTitle}) {
    const dispatch = useDispatch()
  const navigate = useNavigate()
  const {
        transfereeUserErrorMsg,
        transfereeUserSuccessMsg,
        certificateManagement:{certificatesData, newData, showCertificateForm}
    } = useSelector((state) => state.transfereeUser)

  const {
        token,
        userData: {isProfileComplete, user_role}
    } = useSelector((state) => state.authData)

    const {isActive} = useSelector((state) => state.app)

    useEffect(()=>{
      dispatch(clearOnReload())
      dispatch(clearAll())
    }, [])

    const showToastMessage = (msg, isError) => {
      if(isError){
        toast.error(msg, {
            position: toast.POSITION.TOP_RIGHT
        });
      } else{
        toast.success(msg, {
            position: toast.POSITION.TOP_RIGHT
        });
      }
        
    };

    useEffect(()=>{
    if(transfereeUserSuccessMsg){
        let msg;
        if(Array.isArray(transfereeUserSuccessMsg)){
          msg = transfereeUserSuccessMsg[0].toLowerCase().charAt(0).toUpperCase() + transfereeUserSuccessMsg[0].slice(1)
        } else{
          msg = transfereeUserSuccessMsg.toLowerCase().charAt(0).toUpperCase() + transfereeUserSuccessMsg.slice(1)
        }

        dispatch(clearResponseMsg())

        showToastMessage(msg, false)
        
    }

    if(transfereeUserErrorMsg){
      let err
      if(Array.isArray(transfereeUserErrorMsg)){
        err = transfereeUserErrorMsg[0].toLowerCase().charAt(0).toUpperCase()+transfereeUserErrorMsg[0].slice(1)
      }
      else{
        err = transfereeUserErrorMsg.toLowerCase().charAt(0).toUpperCase()+transfereeUserErrorMsg.slice(1)
      }
        dispatch(clearResponseMsg())
        if(err == 'Invalid token'){
          dispatch(logoutUser())
          dispatch(logoutBankUser())
          dispatch(logoutAppUser())
          dispatch(logoutNotapUser())
          dispatch(logoutTransfereeUser())
          err = null
        }else{
          showToastMessage(err, true)
        }

        // showToastMessage(err, true)
    }
    }, [transfereeUserSuccessMsg, transfereeUserErrorMsg])


  return (
    <AppWrapper pageTitle={pageTitle}>
      <>
      {children}
      </>
    </AppWrapper>
  )
}
